import { Route } from 'react-router-dom';

import { OnboardingCompletionGuard } from '@/app/router/OnboardingCompletionGuard';
import { ProtectedRoute } from '@/app/router/ProtectedRoute';

import { ApiPricingScreen } from './pages/ApiPricingScreen';

export const adminPricingRoutes = (
  <Route
    path="/api-pricing"
    element={
      <ProtectedRoute>
        <OnboardingCompletionGuard>
          <ApiPricingScreen />
        </OnboardingCompletionGuard>
      </ProtectedRoute>
    }
  />
);
